<template>
    <div class="categories-view">
      <Categories @open-catalog="navigateToCatalog" />
    </div>
  </template>
  
  <script>
  import Categories from '@/components/product-viewer/Categories.vue';
  
  export default {
    name: 'CategoriesView',
    components: {
      Categories
    },
    methods: {
      navigateToCatalog() {
        this.$router.push('/catalog');
      }
    }
  }
  </script>
  
  <style scoped>
  .categories-view {
    min-height: 100vh;
    width: 100%;
  }
  </style>